import { AbstractControl, ValidationErrors } from '@angular/forms';



export function cpfValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.replace(/\D/g, '');
  if (!value || value.length !== 11 || /^(\d)\1+$/.test(value)) return { cpfInvalid: true };

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += +value[i] * (10 - i);
  let firstCheck = (sum * 10) % 11;
  if (firstCheck === 10) firstCheck = 0;
  if (firstCheck !== +value[9]) return { cpfInvalid: true };

  sum = 0;
  for (let i = 0; i < 10; i++) sum += +value[i] * (11 - i);
  let secondCheck = (sum * 10) % 11;
  if (secondCheck === 10) secondCheck = 0;
  if (secondCheck !== +value[10]) return { cpfInvalid: true };

  return null;
}